'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactRedux = require('react-redux');
var _propTypes = require('prop-types');
var _withFormId = require('../../hocs/with-form-id');
var _withFormId2 = _interopRequireDefault(_withFormId);
var _fieldInfo = require('../../selectors/field-info');
var _vehicleLookup = require('../../selectors/vehicle-lookup');
var _vehicleLookup2 = require('../../actions/vehicle-lookup');
var _input = require('../input');
var _input2 = _interopRequireDefault(_input);
var _inputGroup = require('../input/input-group');
var _gbPlate = require('../../../assets/gb-plate.png');
var _gbPlate2 = _interopRequireDefault(_gbPlate);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var RegLookup = function (_Component) {
  _inherits(RegLookup, _Component);
  function RegLookup() {
    var _ref;
    var _temp, _this, _ret;
    _classCallCheck(this, RegLookup);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RegLookup.__proto__ || Object.getPrototypeOf(RegLookup)).call.apply(_ref, [this].concat(args))), _this), _this.lookupReg = function () {
      _this.props.lookupReg(_this.props.formId, _this.props.product, _this.props.regNo);
    }, _this.setManualView = function () {
      _this.props.setManualView(_this.props.formId);
    }, _this.renderInput = function (props) {
      return _react2.default.createElement(_input.InputWithButton, Object.assign({}, props, {
        name: 'regNo',
        format: 'uppercase',
        handleSubmit: _this.lookupReg,
        fetching: _this.props.fetching,
        valid: _this.props.error ? false : undefined,
        text: 'Find vehicle',
        placeholder: _this.props.placeholder.toUpperCase(),
        css: {
          textAlign: 'center',
          fontWeight: '900',
          fontSize: '22px'
        },
        left: _react2.default.createElement(_inputGroup.InputGroupItem, {
          css: {
            backgroundImage: 'url(' + _gbPlate2.default + ')',
            backgroundSize: 'contain',
            width: '37px'
          }
        })
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(RegLookup, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
        disableManualLookup = _props.disableManualLookup,
        label = _props.label,
        chooseManual = _props.chooseManual;
      return _react2.default.createElement(_input2.default, {
        label: label,
        name: 'regNo',
        input: this.renderInput,
        extra: !disableManualLookup && _react2.default.createElement('a', {
          onClick: this.setManualView
        }, chooseManual)
      });
    }
  }]);
  return RegLookup;
}(_react.Component);
RegLookup.propTypes = {
  // props
  disableManualLookup: _propTypes.bool,
  error: _propTypes.bool,
  label: _propTypes.string.isRequired,
  placeholder: _propTypes.string.isRequired,
  chooseManual: _propTypes.string.isRequired,
  // withFormId
  formId: _propTypes.string.isRequired,
  product: _propTypes.string.isRequired,
  // stp
  fetching: _propTypes.bool.isRequired,
  regNo: _propTypes.string,
  // dtp
  lookupReg: _propTypes.func.isRequired,
  setManualView: _propTypes.func.isRequired
};
RegLookup.defaultProps = {
  regNo: undefined,
  disableManualLookup: false,
  error: false
};
exports.default = (0, _withFormId2.default)((0, _reactRedux.connect)(function (state, ownProps) {
  return {
    fetching: (0, _vehicleLookup.cdlFetching)(state, ownProps.formId),
    regNo: (0, _fieldInfo.getValue)(state, ownProps.formId, 'regNo')
  };
}, {
  lookupReg: _vehicleLookup2.lookupReg,
  setManualView: _vehicleLookup2.setManualView
})(RegLookup));